import { render, staticRenderFns } from "./GeneralPieChart.vue?vue&type=template&id=0df9631e"
import script from "./GeneralPieChart.vue?vue&type=script&lang=js"
export * from "./GeneralPieChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports